import { ColumnStructureItem } from '../types/ColumnStructureItem';
import { compareStrings } from '../../../../util/compareStrings';

export const sortCitiesByName = (
    cities: ColumnStructureItem[],
): ColumnStructureItem[] => {
    return [...cities].sort((a, b) => {
        const cityA = a.city ?? '';
        const cityB = b.city ?? '';
        return compareStrings(cityA, cityB);
    });
};
